import { useMemo } from 'react';
import { Button, Stack, Text } from '@mantine/core';
import { FormattedMessage } from 'react-intl';
import { TransactionCategory } from '@shipstation/financial-services-ui-components';

import { usePaymentAndSubscriptionMegaContext } from '../../../pages/settings/payment-and-subscription/context';

import { messages } from '../../purchase-shipment-volume/messages';

type PaymentMethodSummaryProps = {
  onChangeClick: () => void;
};

export const PaymentMethodSummary = ({ onChangeClick }: PaymentMethodSummaryProps) => {
  const { paymentMethodDetails } = usePaymentAndSubscriptionMegaContext() ?? {};

  const subscriptionPaymentMethod = useMemo(() => {
    return paymentMethodDetails?.find((pm) => pm.assignedPreferences?.includes(TransactionCategory.Subscription));
  }, [paymentMethodDetails]);

  return (
    <Stack align='flex-start' gap={4}>
      <Text fw={600} size='sm'>
        <FormattedMessage
          {...messages.paymentMethodLabel}
          values={{
            paymentMethod: subscriptionPaymentMethod?.nickname || subscriptionPaymentMethod?.paymentMethodDisplayName || '—',
          }}
        />
      </Text>
      <Button onClick={onChangeClick} size='condensed' variant='ghost'>
        <FormattedMessage {...messages.changePaymentMethod} />
      </Button>
    </Stack>
  );
};
